// extracted by mini-css-extract-plugin
export default {"main-layout":"main-layout--2Wa-O","content-container":"content-container--11zXD"};